export const NON_UPDATABLE_FIELDS = ['id', 'createdAt', 'updatedAt'];
